<template>
  <div>
    <div class="row border-bottom">
      <div class="col-md-12 col text-center">
        <h3 v-translate:devices_key="lang">Devices</h3>
      </div>
    </div>

    <div id="main">
      <div id="faq" class="activity1-container activity-section">
        <div v-for="(device, deviceIndex) in 5" :key="deviceIndex" class="card faq-card">
          <div class="card-header faqhead3 text-center">
            <a class="btn btn-header-link">
              {{ `Device ${deviceIndex + 1}` }}
              <label class="toggle-switch float-right">
                <input type="checkbox" id="togBtn" :value="deviceIndex + 1" v-model="checkedDevices" />
                <div class="slider round"></div>
              </label>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Widget } from "@/components/services/participant-service";
export default {
  name: "profile-devices",
  data() {
    return {
      checkedDevices: [],
      pid: "",
      globalElement: null,
      widget: new Widget()
    };
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  mounted() {},
  methods: {
    navigateTab(tab) {
      this.$router.push({
        name: "participants-portal-profile-" + tab,
        params: {}
      });
    }
  }
};
</script>

<style scoped>
#main {
  margin: 33px;
}
.activity1-container {
  min-height: auto;
  padding: 15px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 24px;
}

.toggle-switch input {
  display: none;
}

.toggle-switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #b0bac9;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}

.toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.toggle-switch input:checked + .slider {
  background-color: #2ecc71;
}

.toggle-switch input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

.toggle-switch input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(32px);
}

/*------ ADDED CSS ---------*/
.toggle-switch .slider:after {
  content: "Off";
  color: white;
  display: block;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 60%;
  font-size: 14px;
}

.toggle-switch input:checked + .slider:after {
  content: "On";
  left: 32%;
}

/*--------- END --------*/
</style>
